module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Bold.548f317b.woff2";